var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bg-default h-full w-full"},[_c('div',{attrs:{"id":"errorPage"}},[_c('div',{staticClass:"container"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }